// Timeline interaction functionality for Sacred Valley tour
export function initSacredValleyTimeline() {
    document.querySelectorAll('.flex.md\\:contents').forEach(item => {
        item.addEventListener('mouseenter', () => {
            const dot = item.querySelector('.bg-amber-500');
            if (dot) dot.classList.add('bg-amber-600');
        });
        
        item.addEventListener('mouseleave', () => {
            const dot = item.querySelector('.bg-amber-600');
            if (dot) dot.classList.remove('bg-amber-600');
        });
    });
}

// Export as default
// export default { initSacredValleyTimeline };